import React from 'react';

export default function ProRibbon() {
    return (
        <div className="b2b-ribbon  product-card-header__b2b-ribbon ">
            <span>PRO</span>
        </div>
    );
}
